import { createContext } from 'react';
import { ICreateVideoStudio } from 'types';

export type TTypeOfCreateStudioModalWindow = null | 'toConfirmFieldsClearing' | 'toConfirmSubmit' | 'success' | 'error';

export interface ICreateStudioState {
	name: string;
	dataForSubmit: ICreateVideoStudio | null;
	typeOfModalWindow: TTypeOfCreateStudioModalWindow;
}

export const createStudioInitialState: ICreateStudioState = {
	name: '',
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface ICreateStudioContext extends ICreateStudioState {
	changeName(value: string): void;
	setDataForSubmit(value: ICreateVideoStudio | null): void;
	changeTypeOfModalWindow(value: TTypeOfCreateStudioModalWindow): void;
	resetFields(): void;
}

export const CreateStudioContext = createContext<ICreateStudioContext>({
	changeName: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...createStudioInitialState,
});
